<template>
  <div v-if="amenities.length" class="pa-0">
    <h3 v-if="title" class="font-weight-thin mb-2">Features</h3>
    <div class="d-flex flex-wrap">
      <v-chip
        v-for="amenity in amenities"
        :key="amenity.slug"
        color="white"
        class="mr-2 mb-2 elevation-2"
        small
      >
        {{ amenity.name }}
      </v-chip>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AmenitiesList',
  props: {
    amenities: {
      type: Array,
      default: () => [],
    },
    title: {
      type: Boolean,
      default: true,
    },
  },
}
</script>
